import React from "react";
import logo from "../images/logo.svg";

const Footer = () => {
	return (
		<footer className="py-4 mt-8 ">
			<div className="container">
				{/* top footer */}
				<div className="top">
					<a href="/">
						<img src={logo} alt="" className="logo my-4 " />
					</a>
					<ul className="social flex align-center space-center  gap-2">
						<li>
							<a href="/">
								<i className="fa-brands fa-2x fa-square-facebook"></i>
							</a>
						</li>
						<li>
							<a href="/">
								<i className="fa-brands fa-2x fa-twitter"></i>
							</a>
						</li>
						<li>
							<a href="/">
								<i className="fa-brands fa-2x fa-pinterest"></i>
							</a>
						</li>
						<li>
							<a href="/">
								<i className="fa-brands fa-2x fa-instagram"></i>
							</a>
						</li>
					</ul>
				</div>
				{/* bottom footer */}
				<div className="bottom text-center">
					<section className="my-6 company">
						<h4>Our company</h4>
						<ul className="links">
							<li>
								<a href="/">How we work</a>
							</li>
							<li>
								<a href="/">Why Insure?</a>
							</li>
							<li>
								<a href="/">View plans</a>
							</li>
							<li>
								<a href="/">Reviews</a>
							</li>
						</ul>
					</section>
					<section className="my-6 help">
						<h4>Help me</h4>
						<ul className="links">
							<li>
								<a href="/">FAQ</a>
							</li>
							<li>
								<a href="/">Terms of use</a>
							</li>
							<li>
								<a href="/">Privacy policy</a>
							</li>
							<li>
								<a href="/">Cookies</a>
							</li>
						</ul>
					</section>

					<section className="my-6 contact">
						<h4>Contact</h4>
						<ul className="links">
							<li>
								<a href="/">Sales</a>
							</li>
							<li>
								<a href="/">Support</a>
							</li>
							<li>
								<a href="/">Live chat</a>
							</li>
						</ul>
					</section>
					<section className="my-6 others">
						<h4>Others</h4>
						<ul className="links">
							<li>
								<a href="/">Careers</a>
							</li>
							<li>
								<a href="/">Press</a>
							</li>
							<li>
								<a href="/">Licenses</a>
							</li>
						</ul>
					</section>
				</div>
				<div className="clearfix"></div>
			</div>
		</footer>
	);
};

export default Footer;
